import { Mutation } from 'graphql/generated/graphqlTypes';

export function mockedDeleteRestAPIKeyData(deleteRestApiKey: string): Pick<Mutation, 'deleteRestApiKey'> {
  return {
    deleteRestApiKey
  };
}

export const mockedDeleteRestAPIKeyDataForMutation = mockedDeleteRestAPIKeyData('mock-key-1');
